<template>
  <v-dialog v-model="internalValue" :max-width="maxWidth">
    <v-card :color="backgroundColor" class="pa-4" style="position: relative;">
      <!-- Header slot or fallback to title prop -->
      <div class="dialog-header mb-4">
        <slot name="header">
          <h3 class="font-weight-bold mb-2">{{ title }}</h3>
        </slot>
        <slot name="subtitle">
          <p class="subtitle">{{ subtitle }}</p>
        </slot>
      </div>

      <!-- Body slot for arbitrary form/content -->
      <div class="dialog-body">
        <slot />
      </div>

      <!-- Actions slot or default buttons -->
      <div class="dialog-actions mt-4" style="text-align: right;">
        <slot name="actions">
          <v-btn text color="grey darken-1" dark @click="$emit('cancel')">
            {{ cancelText }}
          </v-btn>
          <v-btn :loading="loading" :color="confirmColor" dark @click="$emit('confirm')">
            {{ confirmText }}
            <template v-slot:loader>
              <span class="custom-loader"><v-icon dark>cached</v-icon></span>
            </template>
          </v-btn>
        </slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    value: { type: Boolean, required: true },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    cancelText: { type: String, default: 'Cancel' },
    confirmText: { type: String, default: 'OK' },
    maxWidth: { type: String, default: '500px' },
    confirmColor: { type: String, default: 'orange darken-1' },
    backgroundColor: { type: String, default: '#f9efd5' },
    loading: { type: Boolean, default: false }
  },
  computed: {
    internalValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  }
}
</script>

<style>
.subtitle { font-size: 16px; color: rgba(0,0,0,0.75); }
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
